import { useGetInvestigatorSites } from './get-investigator-sites/hook';

export const InvestigatorSites = {
  useGetInvestigatorSites,
};
